import styled from 'styled-components'


export const PageStyles = styled.nav({
    color: 'rgb(217, 189, 119)',
    backgroundColor: 'rgb(31, 50, 37)'
});
